/**
 * Makes an API call using the provided configuration.
 *
 * @param {Object} options - The configuration options for the API call.
 * @param {'get'|'post'|'put'|'delete'|'patch'} options.method - The HTTP method to use for the request.
 * @param {string} options.url - The endpoint URL for the API call.
 * @param {Object} [options.data=null] - The request payload for POST, PUT, or PATCH requests.
 * @param {Object} [options.params=null] - The URL query parameters for the request.
 * @returns {Promise<any>} The response from the API call.
 *
 * @example
 * // Example usage:
 * const response = await apiCall({
 *   method: 'get',
 *   url: '/users',
 *   params: { id: 1 }
 * });
 */
import apiClient from "./apiClient";

export const apiCall = ({ method, url, data = null, params = null, config = {} }) => {
  return apiClient({ method, url, data, params, ...config });
};
